import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@ib-env/environment';
import { createHttpParams } from '@ib-shared/helpers/create-http-params';
import { IDashboardTransactionsResponse } from '@ib-shared/interfaces/dashboard-table-row.intf';
import { IPagination } from '@ib-shared/interfaces/pagination.intf';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DashboardHttpService {
  constructor(private http: HttpClient) {}
  IPaginationMeta;
  public fetchTableRows(
    params: IPagination,
  ): Observable<IDashboardTransactionsResponse> {
    return this.http
      .get<IDashboardTransactionsResponse>(
        `${environment.apiUrl}/api/investortransactions`,
        { params: createHttpParams(params) },
      )
      .pipe(
        map(r => {
          r?.data?.forEach(i => {
            if (i.debit === '-') {
              i.debit = null;
            }
          });
          return r;
        }),
      );
  }
}
